// frontend/src/components/quizzes/QuizStatsCard.tsx

import { QuizStats } from '../../types/quiz.types';

interface QuizStatsCardProps {
  stats: QuizStats | null;
  isLoading: boolean;
}

export function QuizStatsCard({ stats, isLoading }: QuizStatsCardProps) {
  return (
    <div className="card">
      <h3 className="quiz-card-title">Quiz İstatistiklerim</h3>
      {isLoading || !stats ? (
        <p className="quiz-stats-loading">Yükleniyor...</p>
      ) : (
        <div className="quiz-stats-list">
          <div className="quiz-stats-row">
            <span>Toplam Quiz</span>
            <span className="quiz-stats-value">{stats.totalQuizzes}</span>
          </div>
          <div className="quiz-stats-row">
            <span>Ortalama Başarı</span>
            <span className="quiz-stats-value primary">%{stats.averageScore}</span>
          </div>
        </div>
      )}
    </div>
  );
}
